import { List, ListItem, ListItemText } from '@mui/material';
import React from 'react';
import { SidebarPanel } from '../SidebarPanel';

export const PopularNewsItems: React.FC = (): JSX.Element => {
  const news = [
    {
      id: 1,
      title: 'Aanmelden geopend voor de jaarlijkse verenigings-BBQ',
      views: 817,
    },
    {
      id: 2,
      title: 'Inschrijving voor competitie Zwartkruid nu geopend',
      views: 722,
    },
    {
      id: 3,
      title: 'Nieuwe trainingsavonden toegevoegd aan de verenigingsagenda',
      views: 90,
    },
  ];

  return (
    <SidebarPanel title="🔥 Populaire Nieuwsberichten">
      <List>
        {news.map((competition, index) => (
          <ListItem key={competition.id} divider={index < news.length - 1}>
            <ListItemText
              primary={competition.title}
              secondary={`${competition.views} weergave`}
            />
          </ListItem>
        ))}
      </List>
    </SidebarPanel>
  );
};
